import * as React from 'react';
import { createSubcomponent, createElemPropsHook, } from '@workday/canvas-kit-react/common';
import { Grid } from '@workday/canvas-kit-react/layout';
import { useListRenderItems } from '@workday/canvas-kit-react/collection';
import { useSegmentedControlModel } from './hooks/useSegmentedControlModel';
export const useSegmentedControlList = createElemPropsHook(useSegmentedControlModel)(({ state: { orientation, disabled, items } }) => {
    const directionName = orientation === 'vertical' ? 'Row' : 'Column';
    return {
        [`gridTemplate${directionName}s`]: `repeat(${items.length}, 1fr)`,
        opacity: disabled ? 0.4 : undefined,
    };
});
export const SegmentedControlList = createSubcomponent('div')({
    displayName: 'SegmentedControl.List',
    modelHook: useSegmentedControlModel,
    elemPropsHook: useSegmentedControlList,
})(({ children, ...elemProps }, Element, model) => {
    return (React.createElement(Grid, Object.assign({ as: Element, display: "inline-grid", role: "group", backgroundColor: "soap200", border: "1px solid transparent", borderColor: "licorice200", borderRadius: "l", padding: "3px", gridGap: "xxs" }, elemProps), useListRenderItems(model, children)));
});
